export function strStartsWith(haystack: string, needle: string): boolean {
    return haystack.lastIndexOf(needle, 0) === 0;
}

export function strEndsWith(haystack: string, needle: string): boolean {
    return haystack.indexOf(needle, haystack.length - needle.length) !== -1;
}

export function strContains(haystack: string, needle: string): boolean {
    return haystack.indexOf(needle) >= 0;
}

export function strTrimSpaces(str: string): string {
    return str.replace(/\s/g, '');
}

export function strTrimPrefix(str: string, prefix: string): string {
    return strStartsWith(str, prefix)
        ? str.substr(prefix.length)
        : str;
}

export function strTrimSuffix(str: string, suffix: string): string {
    return strEndsWith(str, suffix)
        ? str.substring(0, str.length - suffix.length)
        : str;
}

export function strCapitalize(str: string): string {
    return str.charAt(0).toUpperCase() + str.slice(1);
}

export function strToJSON<T>(str: string): T | null {
    let result: T | null = null;
    if (str.trim().length > 0) {
        try {
            result = JSON.parse(str);
        } catch (e) {
            // Response is not JSON
        }
    }
    return result;
}

export function strReplace(str: string, search: string, replacement: string): string {
    return str.split(search).join(replacement);
}

export function strContainsLetters(str: string) {
    return /[a-z]/i.test(str);
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/services/strings.ts